module.exports = "/images/carrinho_vazio.png?a790950e273c927f280b39392f8c0076";